import { Injectable } from '@angular/core';
import { Observable, Observer, combineLatest } from 'rxjs';
import { pickBy } from 'lodash';
import { environment } from '../../environments/environment';
import { CspConfigService } from './csp-config.service';

interface IScriptModel {
  name: string;
  src: string;
  loaded: boolean;
}
declare var document: any;

@Injectable({
  providedIn: 'root'
})
export class DynamicScriptLoaderService {

  private scripts: any = {
    'google': {
      src: `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsKey}&libraries=places`,
      loaded: false
    },
    'gaode': {
      src: 'https://webapi.amap.com/loader.js',
      loaded: false
    }
  };

  constructor(private readonly cspConfig: CspConfigService) {}

  import(scripts: string[]) {
    return combineLatest([
      this.loadObservables(scripts[0]),
      // this.loadObservables(scripts[1]),
    ]);
  }

  private loadObservables(script: any): Observable<IScriptModel> {
    return new Observable<IScriptModel>((observer: Observer<IScriptModel>) => {
      if (script) {
        const existingScript = pickBy(this.scripts, function (value, key) {
          return key === script ? value : null;
        });
        if (existingScript && existingScript[script].loaded) {
          observer.next(existingScript[script].src);
          observer.complete();
        } else {
          const scriptElement = document.createElement('script');
          scriptElement.type = 'text/javascript';
          scriptElement.async = true;
          scriptElement.defer = true;
          scriptElement.nonce = this.cspConfig.getCspNonce();
          scriptElement.src = existingScript[script].src;
          scriptElement.onload = () => {
            existingScript[script].loaded = true;
            observer.next(existingScript[script].src);
            observer.complete();
          };
          scriptElement.onerror = (error: any) => {
            observer.error('Couldn\'t load script ' + existingScript[script].src);
          };
          document.getElementsByTagName('body')[0].appendChild(scriptElement);
        }
      }
    });
  }

  load(scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  private loadScript(name: string) {
    return new Promise((resolve, reject) => {
      if (!this.scripts[name].loaded) {
        // load script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = this.scripts[name].src;
        script.nonce = this.cspConfig.getCspNonce();
        if (script.readyState) {  // IE
          script.onreadystatechange = () => {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve({ script: name, loaded: true, status: 'Loaded' });
            }
          };
        } else {  // Others
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          };
        }
        script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      }
    });
  }

}
